import React, { useState } from "react";
import axios from "axios";
import { NavLink } from 'react-router-dom';
// If using Bootstrap Icons, ensure you've installed and imported them, e.g.:
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap-icons/font/bootstrap-icons.css";

const Register = () => {
  const [user, setUser] = useState({
    fname: "",
    lname: "",
    username: "",
    email: "",
    password: "",
    usertype: "user", // Default user type
  });

  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const validateForm = () => {
    if (!user.fname || !user.lname || !user.username || !user.email || !user.password) {
      setError("All fields are required.");
      return false;
    }
    if (!/\S+@\S+\.\S+/.test(user.email)) {
      setError("Please enter a valid email address.");
      return false;
    }
    if (user.password.length < 6) {
      setError("Password must be at least 6 characters long.");
      return false;
    }
    return true;
  };

  const submitForm = (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setError("");
    axios
      .post("https://api.mitradingjp.com/register.php", user)
      .then((response) => {
        if (response.data.Status === "201") {
          setMessage("Registration successful. Please log in.");
          setUser({
            fname: "",
            lname: "",
            username: "",
            email: "",
            password: "",
            usertype: "user",
          });
        } else {
          setMessage(response.data.Message || "Registration failed. Try again.");
        }
      })
      .catch((error) => {
        console.error(error);
        setMessage("An error occurred. Please try again later.");
      });
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        // Diagonal striped background
        background:
          "repeating-linear-gradient(45deg, #f7f7f7, #f7f7f7 15px, #eaeaea 15px, #eaeaea 30px)",
      }}
    >
      {/* Circular container for the form */}
      <div
        style={{
          width: "680px",
          height: "680px",
          backgroundColor: "#147D9B", // Teal color
          borderRadius: "50%",
          position: "relative",
          boxShadow: "10px 10px 2px rgba(0,0,0,0.1)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          paddingTop: "50px",
          paddingBottom: "20px",
        }}
      >
        {/* Title */}
        <p style={{ color: "#fff", margin: 0, fontSize: "0.85rem" }}>
          Already a member ?
        </p>
        <NavLink to="/login"><h2 style={{ color: "#fff", marginBottom: "5px", marginBottom: "20px" }}>Log in!</h2></NavLink>
        <p style={{ color: "#fff", margin: 0, fontSize: "0.85rem" }}>
          Enter your details to <span style={{fontSize:"30px", color:"#ffffff", marginLeft:"10px"}}> Sign up!</span>
        </p>

        {/* Success or error messages */}
        {message && (
          <div
            style={{
              width: "80%",
              backgroundColor: "#d4edda",
              color: "#155724",
              padding: "8px",
              borderRadius: "4px",
              textAlign: "center",
              marginTop: "10px",
              fontSize: "0.9rem",
            }}
          >
            {message}
          </div>
        )}
        {error && (
          <div
            style={{
              width: "80%",
              backgroundColor: "#f8d7da",
              color: "#721c24",
              padding: "8px",
              borderRadius: "4px",
              textAlign: "center",
              marginTop: "10px",
              fontSize: "0.9rem",
            }}
          >
            {error}
          </div>
        )}

        {/* Registration form */}
        <form
          onSubmit={submitForm}
          style={{
            width: "50%",
            display: "flex",
            flexDirection: "column",
            marginTop: "15px",
          }}
        >
          {/* First Name */}
          <div style={{ position: "relative", marginBottom: "15px" }}>
            <input
              type="text"
              name="fname"
              placeholder="First Name"
              value={user.fname}
              onChange={handleChange}
              required
              style={{
                paddingLeft: "36px",
                borderRadius: "20px",
                border: "none",
                width: "100%",
                boxShadow: "0 0 5px rgba(0,0,0,0.1)",
                height: "40px",
              }}
            />
            <i
              className="bi bi-person-fill"
              style={{
                position: "absolute",
                top: "50%",
                left: "10px",
                transform: "translateY(-50%)",
                color: "#999",
              }}
            ></i>
          </div>

          {/* Last Name */}
          <div style={{ position: "relative", marginBottom: "15px" }}>
            <input
              type="text"
              name="lname"
              placeholder="Last Name"
              value={user.lname}
              onChange={handleChange}
              required
              style={{
                paddingLeft: "36px",
                borderRadius: "20px",
                border: "none",
                width: "100%",
                boxShadow: "0 0 5px rgba(0,0,0,0.1)",
                height: "40px",
              }}
            />
            <i
              className="bi bi-person-lines-fill"
              style={{
                position: "absolute",
                top: "50%",
                left: "10px",
                transform: "translateY(-50%)",
                color: "#999",
              }}
            ></i>
          </div>

          {/* Username */}
          <div style={{ position: "relative", marginBottom: "15px" }}>
            <input
              type="text"
              name="username"
              placeholder="Username"
              value={user.username}
              onChange={handleChange}
              required
              style={{
                paddingLeft: "36px",
                borderRadius: "20px",
                border: "none",
                width: "100%",
                boxShadow: "0 0 5px rgba(0,0,0,0.1)",
                height: "40px",
              }}
            />
            <i
              className="bi bi-person-check"
              style={{
                position: "absolute",
                top: "50%",
                left: "10px",
                transform: "translateY(-50%)",
                color: "#999",
              }}
            ></i>
          </div>

          {/* Email */}
          <div style={{ position: "relative", marginBottom: "15px" }}>
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={user.email}
              onChange={handleChange}
              required
              style={{
                paddingLeft: "36px",
                borderRadius: "20px",
                border: "none",
                width: "100%",
                boxShadow: "0 0 5px rgba(0,0,0,0.1)",
                height: "40px",
              }}
            />
            <i
              className="bi bi-envelope-fill"
              style={{
                position: "absolute",
                top: "50%",
                left: "10px",
                transform: "translateY(-50%)",
                color: "#999",
              }}
            ></i>
          </div>

          {/* Password */}
          <div style={{ position: "relative", marginBottom: "15px" }}>
            <input
              type="password"
              name="password"
              placeholder="Password"
              value={user.password}
              onChange={handleChange}
              required
              style={{
                paddingLeft: "36px",
                borderRadius: "20px",
                border: "none",
                width: "100%",
                boxShadow: "0 0 5px rgba(0,0,0,0.1)",
                height: "40px",
              }}
            />
            <i
              className="bi bi-lock-fill"
              style={{
                position: "absolute",
                top: "50%",
                left: "10px",
                transform: "translateY(-50%)",
                color: "#999",
              }}
            ></i>
          </div>

          {/* User Type */}
          <div style={{ position: "relative", marginBottom: "15px" }}>
            <select
              name="usertype"
              value={user.usertype}
              onChange={handleChange}
              required
              style={{
                paddingLeft: "36px",
                borderRadius: "20px",
                border: "none",
                width: "100%",
                boxShadow: "0 0 5px rgba(0,0,0,0.1)",
                height: "40px",
                appearance: "none",
                background: "#fff url('data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjOTk5IiB2aWV3Qm94PSIwIDAgMTIgMTIiIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiI+PHBvbHlsaW5lIHBvaW50cz0iMSAzIDYgOCAxMSAzIi8+PC9zdmc+') no-repeat 96% center",
              }}
            >
              <option value="user">User</option>
              <option value="admin">Admin</option>
              <option value="administrator">Administrator</option>
            </select>
            <i
              className="bi bi-list-check"
              style={{
                position: "absolute",
                top: "50%",
                left: "10px",
                transform: "translateY(-50%)",
                color: "#999",
              }}
            ></i>
          </div>

          {/* Submit button */}
          <button
            type="submit"
            style={{
              width: "100%",
              backgroundColor: "#8CC63F", // Greenish
              color: "#fff",
              border: "none",
              borderRadius: "20px",
              padding: "10px 0",
              fontWeight: "bold",
              fontSize: "16px",
              boxShadow: "0 0 5px rgba(0,0,0,0.2)",
              cursor: "pointer",
            }}
          >
            Register
          </button>
        </form>
      </div>
    </div>
  );
};

export default Register;
